import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { usePageTitle } from "hooks";
import {
  decodeQueryStringData,
  urlQueryParamsToObject,
} from "utils/commonFunction";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { actions } from "models/Slices/FilterSlice";
import CreateNewListingWithoutMetadataForm from "./CreateNewListingWithoutMetadataForm";
import { IdleTimerProvider } from "react-idle-timer";
import { AppSetting } from "utils/appSettings";
import { dataSource } from "models/Slices/GlobalSlice";

const CreateNewZoneListingWithoutMetadataPage: React.FC = () => {
  usePageTitle("New Listing");
  const location = useLocation();
  const [requestedEventId, setRequestedEventId] = useState<number | null>(null);
  const dispatch = useAppDispatch();
  const DataSource = useAppSelector(dataSource);
  
  useEffect(() => {
    const locationSearch = location.search;
    if (locationSearch && locationSearch.includes("event")) {
      const queryObject = urlQueryParamsToObject(locationSearch);
      if (queryObject.event) {
        let filterQueryString = decodeQueryStringData(queryObject.event);
        if (filterQueryString.event_id) {
          setRequestedEventId(filterQueryString.event_id);
        }
      }
      dispatch(actions.getSplitTypeData({ env: DataSource }));
    }
  }, []);
  return (
    <IdleTimerProvider
          timeout={1000 * AppSetting.IDLE_TIME_TIMEOUT_IN_SECONDS}
    >
      <div className="mainHeading">
        <div>
          <h2>New Listing</h2>
        </div>
      </div>
      {requestedEventId && (
        <CreateNewListingWithoutMetadataForm
          requestedEventId={requestedEventId}
        />
      )}
      
    </IdleTimerProvider>
  );
};

export default CreateNewZoneListingWithoutMetadataPage;
